/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as ChooseTierIcon } from "../../../resources/images/choose-tier-lep.svg";

/* Styles */
import styles from "./styles";

const ChooseTierModal = ({
  showModal,
  setShowModal,
  updateTier,
  activeUser,
  pointDifference,
  initialSelectedTier,
  tiersList,
  userPreviousTier,
  allowConciergeKey
}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <UCModal
      className={classes.chooseTierModal}
      customStyle={classes.chooseTierModalWrapper}
      showModal={showModal}
      setShowModal={setShowModal}
      modalIcon={<ChooseTierIcon />}
      modalTitle={<FormattedMessage id="loyaltyChooseTier.title" />}
      modalDescription={
        <FormattedMessage
          id="loyaltyChooseTier.subtitle"
          values={{
            firstName: activeUser?.firstName,
            lastName: activeUser?.lastName,
          }}
        />
      }
      modalContent={
        <Content
          setShowModal={setShowModal}
          updateTier={updateTier}
          activeUser={activeUser}
          pointDifference={pointDifference}
          initialSelectedTier={initialSelectedTier}
          tiersList={tiersList}
          userPreviousTier={userPreviousTier}
          allowConciergeKey={allowConciergeKey}
        />
      }
      dataTestId="chooseTierModal"
    />
  );
};

export default ChooseTierModal;
